import React from 'react';

const UserContext = React.createContext({});
UserContext.displayName = 'UserProfile';

export default UserContext;